import type { ReactNode } from "react";
import { ReceiptText } from "lucide-react";
import { Typography } from "@akuna/ui";

export function ComandaSectionLayout({ title, badge, action, search, children, totalLabel, total }: { title: string; badge?: ReactNode; action?: ReactNode; search?: ReactNode; children: ReactNode; totalLabel: string; total: string }) {
  return <section className="overflow-hidden rounded-2xl border border-border bg-card">
    <div className="flex flex-wrap items-center justify-between gap-3 border-b border-border px-4 py-3">
      <div className="flex items-center gap-2"><ReceiptText className="h-4 w-4 text-akuna-orange" aria-hidden="true" /><Typography variant="h5">{title}</Typography>{badge}</div>
      {action}
    </div>
    {search ? <div className="border-b border-border px-4 py-3">{search}</div> : null}
    {children}
    <div className="flex items-center justify-between border-t border-border bg-cream-50 px-4 py-4"><Typography variant="h5">{totalLabel}</Typography><Typography asChild variant="h4"><span className="tabular-nums">{total}</span></Typography></div>
  </section>;
}
